import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'

// Components
import SEO from '../../components/seo'
import Hero from '../../components/hero'
import ContentCard from '../../components/contentCard'

// Strings
import strings from './strings'

// Styles
const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'grid',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      display: 'block',
			columns: '2 350px',
			gap: theme.spacing(3),
    },
	},
	card: {
		// marginBottom: theme.spacing(3),
		breakInside: 'avoid',
    pageBreakInside: 'avoid',
	}
}))

const AboutPage = (props) => {
  // console.log('👾 AboutPage > ', props)

	const classes = useStyles()
	
  const { hero, cards } = props.data.prismicAbout.data

  return (
    <>
      <SEO title={props.data.prismicAbout.data.hero[0].title} />
      <Hero {...hero[0]} />

      <Container className={classes.wrapper} maxWidth="lg">
				{cards && cards.map((card, i) => <ContentCard key={i} {...card} styles={classes.card} />)}
      </Container>
    </>
  )
}

export default AboutPage

AboutPage.propTypes = {}